/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRuleDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestrictionRuleDetailTestIds = {
  badgeActive: "badge-active",
  badgeInactive: "badge-inactive",
  badgeOpenViolations: "badge-open-violations",
  badgeViolations: "badge-violations",
  btnActivate: "btn-activate",
  btnDeactivate: "btn-deactivate",
  btnEdit: "btn-edit",
  btnTestRestrictionRule: "btn-test-restriction-rule",
  cardRuleDetails: "card-rule-details",
  colProfileCode: "col-profile-code",
  colProfileName: "col-profile-name",
  colResource: "col-resource",
  colSystem: "col-system",
  dialogActivateRule: "dialog-activate-rule",
  dialogDeactivateRule: "dialog-deactivate-rule",
  linkOpenRequest: "link-open-request",
  linkViolations: "link-violations",
  openRequestBanner: "open-request-banner",
  restrictionRuleDetailPage: "restriction-rule-detail-page",
  ruleConditionExpr: "rule-condition-expr",
  ruleGraceDays: "rule-grace-days",
  ruleInfoCard: "rule-info-card",
  ruleStatus: "rule-status",
  sectionConditionExpression: "section-condition-expression",
  sectionDeniedProfiles: "section-denied-profiles",
  linkAccessProfile: (profile_accessProfile_id: string) => `link-access-profile-${profile_accessProfile_id}`,
  linkAccessProfilePrefix: () => "link-access-profile-" as TestIdPrefix
} as const;
